var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mt-header',{staticClass:"header",attrs:{"title":"限时抢购"}},[(_vm.isShowBack)?_c('header-item',{attrs:{"slot":"left","isBack":""},on:{"onclick":_vm.leftClick},slot:"left"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72636d88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/flashsale-list/child/ProductListHeader.vue
// module id = null
// module chunks = 